/**
 * BuriedVerse CTA demo plates — 3 variants x {subscribe, comment}.
 * Same plate + same fact tag + same hero card in every one, so the only variable is the
 * CTA treatment (fair compare, same rule the concept proofs used).
 *
 * The fact tag (top-left) and hero card (bottom) are LIVE in each frame on purpose: these
 * renders are the proof that the right-middle CTA band does not collide with either.
 */
import { AbsoluteFill, Img, staticFile } from "remotion";
import { BvFactTag, BvHero } from "./BuriedVerseOverlayDemo";
import { BvCtaPinned, BvCtaRule, BvCtaSeal, BvCtaFadeOut } from "./BuriedVerseCta";

/* 96f @16fps = 6.0s. Beat map (research-set):
     f0-8    plate + tag + hero only
     f8-16   CTA entrance (8f = 500ms)
     f16-90  HOLD, fully static (4.6s reading window)
     f90-96  exit (6f = 375ms, ease-in — faster than the entrance on purpose) */
const Stage: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <AbsoluteFill>
    <Img src={staticFile("bv_demo/p1_merimnao.jpg")} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
    {/* the two existing slots, live, so any overlap would be visible */}
    <BvFactTag kicker="Citation" value="Matthew 6 · the birds of the air" />
    <BvHero
      variant="myth"
      kicker="The myth"
      headline={'Merimnao does not mean "to be divided."'}
    />
    {children}
  </AbsoluteFill>
);

export const BvCtaA_Subscribe: React.FC = () => (
  <Stage>
    <BvCtaFadeOut dur={96}>
      <BvCtaPinned kind="subscribe" startFrame={8} />
    </BvCtaFadeOut>
  </Stage>
);
export const BvCtaA_Comment: React.FC = () => (
  <Stage>
    <BvCtaFadeOut dur={96}>
      <BvCtaPinned kind="comment" startFrame={8} />
    </BvCtaFadeOut>
  </Stage>
);
export const BvCtaB_Subscribe: React.FC = () => (
  <Stage>
    <BvCtaFadeOut dur={96}>
      <BvCtaRule kind="subscribe" startFrame={8} />
    </BvCtaFadeOut>
  </Stage>
);
export const BvCtaB_Comment: React.FC = () => (
  <Stage>
    <BvCtaFadeOut dur={96}>
      <BvCtaRule kind="comment" startFrame={8} />
    </BvCtaFadeOut>
  </Stage>
);
export const BvCtaC_Subscribe: React.FC = () => (
  <Stage>
    <BvCtaFadeOut dur={96}>
      <BvCtaSeal kind="subscribe" startFrame={8} />
    </BvCtaFadeOut>
  </Stage>
);
export const BvCtaC_Comment: React.FC = () => (
  <Stage>
    <BvCtaFadeOut dur={96}>
      <BvCtaSeal kind="comment" startFrame={8} />
    </BvCtaFadeOut>
  </Stage>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
